import React from 'react';
import { StarIcon } from 'lucide-react';
const testimonials = [{
  text: 'Mi perro tuvo una convulsión y gracias a esta guía supe exactamente qué hacer. Me dio seguridad hasta llegar al veterinario.',
  name: 'Mariana G.',
  avatar: 'https://randomuser.me/api/portraits/women/44.jpg'
}, {
  text: 'Es claro, práctico y fácil de entender. Lo tengo guardado en el celular por cualquier emergencia.',
  name: 'Sofía M.',
  avatar: 'https://randomuser.me/api/portraits/women/68.jpg'
}, {
  text: 'Lo que más me ayudó fue saber qué NO hacer. En una urgencia uno se desespera.',
  name: 'Valentina P.',
  avatar: 'https://randomuser.me/api/portraits/women/65.jpg'
}, {
  text: 'Está todo organizado por tipo de emergencia. Encontrás lo que necesitás en segundos.',
  name: 'Diego M.',
  avatar: 'https://randomuser.me/api/portraits/men/32.jpg'
}];
export function TestimonialsSection() {
  return <section className="bg-[#F9FAFB] py-16 px-4" data-id="element-169">
      <div className="max-w-[1200px] mx-auto" data-id="element-170">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-[#111827]" data-id="element-171">
          Lo que dicen quienes ya lo tienen
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-172">
          {testimonials.map((t, i) => <div key={i} className="bg-white rounded-2xl p-6 shadow-md border border-gray-100 flex flex-col justify-between hover:shadow-lg transition-shadow duration-300" data-id="element-173">
              <div data-id="element-174">
                <div className="flex gap-1 mb-4" data-id="element-175">
                  {[...Array(5)].map((_, j) => <StarIcon key={j} className="w-5 h-5 fill-[#FBBF24] text-[#FBBF24]" data-id="element-176" />)}
                </div>
                <p className="text-[#374151] text-[15px] leading-relaxed mb-6 italic" data-id="element-177">
                  "{t.text}"
                </p>
              </div>

              <div className="flex items-center gap-3 pt-4 border-t border-gray-50" data-id="element-178">
                <img src={t.avatar} alt={t.name} className="w-10 h-10 rounded-full object-cover border-2 border-white shadow-sm" data-id="element-179" />
                <p className="text-[#111827] font-bold text-sm" data-id="element-180">{t.name}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}